/** Dispatched when bootstrap fails with a chunk-like error so the recovery service can react. */
export const CHUNK_LOAD_FAILURE_EVENT = 'inlightened-chunk-load-failure';

/**
 * Whether to run auto-reload / prompt recovery for stale lazy chunks (post-deploy 404 on hashed JS).
 * Skip local shells only: default `environment` (empty name), `localapi`, and `dev` ng serve.
 */
export function isChunkLoadRecoveryEnabledForEnvironment(env: { name: string }): boolean {
  const { name } = env;
  return name !== '' && name !== 'localapi' && name !== 'dev';
}

/**
 * Notify listeners (ChunkLoadRecoveryService) that a chunk failure occurred during bootstrap.
 */
export function dispatchChunkLoadFailureEvent(): void {
  if (typeof window === 'undefined') {
    return;
  }
  window.dispatchEvent(new CustomEvent(CHUNK_LOAD_FAILURE_EVENT));
}
